import { render } from "./Content.vue?vue&type=template&id=5c4cf044&scoped=true&ts=true"
import script from "./Content.vue?vue&type=script&lang=ts"
export * from "./Content.vue?vue&type=script&lang=ts"

import "./Content.vue?vue&type=style&index=0&id=5c4cf044&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c4cf044"]])

export default __exports__